<template>
  <el-dialog
      :visible.sync="visible"
      title="库存调配"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="100px"
    >
      <el-row :gutter="16">
        <!--        <el-col :span="6">-->
        <!--          <el-form-item label="清单号：" prop="batchCode">-->
        <!--            <el-input v-model="dataForm.batchCode" size="mini"></el-input>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <el-col :span="6">
          <el-form-item label="调出方：" prop="checkOutStorageId">
            <storages
                v-model="dataForm.checkOutStorageId"
                :disabled="true"
                size="mini"
            ></storages>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="接收方：" prop="checkInStorageId">
            <storages v-model="dataForm.checkInStorageId" size="mini"></storages>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="调仓时间：" prop="operateTime">
            <el-date-picker
                v-model="dataForm.operateTime"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="`选择出调配时间`"
                size="mini"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="新合同号：" prop="agreementCode">
            <order-drop v-model="dataForm.agreementCode" size="mini"></order-drop>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注：" label-width="70px" prop="remark">
            <el-input v-model="dataForm.remark" size="mini"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-table :data="dataForm.detailList" border style="width: 100%">
        <el-table-column
            label="行号"
            type="index"
            header-align="center"
            align="center"
            width="50"
        ></el-table-column>
        <el-table-column
            label="品番号"
            prop="product.code"
            header-align="center"
            align="center"
            v-if="productType==='产品'"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.product.code'"
                :rules="detailRule.txtInput"
                label-width="0"
                style="margin-bottom: 0px"

            >
              <el-input v-model="scope.row.product.code" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="SKU"
            prop="product.skuCode"
            header-align="center"
            align="center"
            v-if="productType==='产品'"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.product.skuCode'"
                label-width="0"
                style="margin-bottom: 0px"

            >
              <el-input v-model="scope.row.product.skuCode" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="品名"
            prop="product.name"
            header-align="center"
            align="center"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.product.name'"
                :rules="detailRule.txtInput"
                label-width="0"
                style="margin-bottom: 0px"

            >
              <el-input v-model="scope.row.product.name" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--            label="中文品名"-->
        <!--            prop="nameZh"-->
        <!--            header-align="center"-->
        <!--            align="center"-->
        <!--            v-if="productType==='产品'"-->
        <!--        ></el-table-column>-->
        <el-table-column
            label="颜色"
            prop="product.color"
            header-align="center"
            align="center"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.product.color'"
                label-width="0"
                style="margin-bottom: 0px"

            >
              <el-input v-model="scope.row.product.color" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="规格"
            prop="product.size"
            header-align="center"
            align="center"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.product.size'"
                label-width="0"
                style="margin-bottom: 0px"

            >
              <el-input v-model="scope.row.product.size" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="幅宽"
            prop="attr1"
            header-align="center"
            align="center"
            v-if="productType==='原料'"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.product.code'"
                :rules="detailRule.count"
                label-width="0"
                style="margin-bottom: 0px"

            >
              <el-input v-model="scope.row.count" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="克重"
            prop="attr2"
            header-align="center"
            align="center"
            v-if="productType==='原料'"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.product.code'"
                :rules="detailRule.count"
                label-width="0"
                style="margin-bottom: 0px"

            >
              <el-input v-model="scope.row.count" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--            label="成本单价"-->
        <!--            prop="price"-->
        <!--            header-align="center"-->
        <!--            align="center"-->
        <!--            width="160"-->
        <!--        >-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-form-item-->
        <!--                :prop="'detailList.' + scope.$index + '.price'"-->
        <!--                :rules="detailRule.price"-->
        <!--                label-width="0"-->
        <!--                style="margin-bottom: 0px"-->

        <!--            >-->
        <!--              <el-input v-model="scope.row.price" size="mini"></el-input>-->
        <!--            </el-form-item>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column label="调出数量" header-align="center" align="center" width="160">
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.count'"
                :rules="detailRule.count"
                label-width="0"
                style="margin-bottom: 0px"

            >
              <el-input v-model="scope.row.count" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right" header-align="center" align="center">
          <template #default="{row,$index}">
            <el-button type="text" @click="removeRow(row,$index)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel" size="mini">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="doSubmit()" size="mini">确认调仓</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { isNumber, moneyValidator } from '@/utils/validate'

export default {
  props: {
    productType: ''
  },
  data () {
    return {
      dataForm: {},
      visible: false,
    }
  },
  computed: {
    dataRule () {
      return {
        shippingCost: [{ validator: moneyValidator, trigger: 'change' }],
        checkOutStorageId: [
          { required: true, message: '请选择调出仓库', trigger: 'change' },
        ],
        checkInStorageId: [
          { required: true, message: '请选择接收仓库', trigger: 'change' },
        ],
        operateTime: [
          { required: true, message: '请选择调仓时间', trigger: 'change' },
        ],
      }
    },
    detailRule () {
      return {
        txtInput: [
          { required: true, message: '请填写', trigger: 'change' },
        ],
        price: [
          { required: true, message: '请填写单价', trigger: 'change' },
          {
            validator: moneyValidator
          }
        ],
        count: [
          { required: true, message: '请填写数量', trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              if (!isNumber(value)) {
                callback(new Error('请输入正确的数量'))
              }
              callback()
            },
            trigger: 'change',
          },
          {
            validator: function (rule, value, callback) {
              if (value<=0) {
                callback(new Error('请输入正确的数量'))
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      }
    },
  },
  methods: {
    cancel () {
      this.visible = false
    },
    init () {
      this.visible = true
      this.reset()
    },
    reset () {
      this.dataForm = {
        ...this.dataForm,
        agreementCode: '',
        checkInStorageId: '',
        shippingCost: '',
        remark: '',
        operateTime: '',
        batchCode: ''
      }
      this.queryUpStore()
      if (this.$refs.dataForm) {
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate()
        })
      }
    },
    removeRow (row, $index) {
      this.$confirm(`是否要将改行数据移出本次操作?`).then(() => {
        this.dataForm.detailList.splice($index, 1)
      })
    },
    async queryUpStore () {
      let loading = this.$loading()
      let params = this.dataForm.detailList.map(row => {
        return {
          orderId: row.agreementId,
          productId: row.productId,
          productType: this.productType
        }
      })
      try {
        let dataList = await this.$api.post(`/erp/store/query/up_store`, params)
        if (dataList) {
          dataList.forEach(row => {
            row.count = 0
            row.showReason = '相关物料'
          })
        }
        this.dataForm.detailList = this.dataForm.detailList.concat(dataList)
        loading.close()
      } catch (e) {
        console.log(e)
        loading.close()
      }
    },
    async doSubmit () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return
        }
        // 验证数量不能为0
        this.$confirm('是否进行库存调配操作?', '操作提示').then(() => {
          this.saveData()
        })
      })
    },
    async saveData () {
      let postForm = {
        agreementCode: this.dataForm.agreementCode,
        checkInStorageId: this.dataForm.checkInStorageId,
        remark: this.dataForm.remark,
        operateTime: this.dataForm.operateTime,
        detailList: this.dataForm.detailList.map((item) => {
          return {
            id: item.id,
            agreementId: item.agreementId,
            count: item.count,
            product: item.product
          }
        }),
      }

      const data = await this.$api2.post(`/erp/store/transfer`, postForm)
      this.$message.success('操作成功')
      this.$emit('success')
      this.visible = false
    },
  },
}
</script>
